export const emojies = [
  '😀',
  '😁',
  '😂',
  '🤣',
  '😃',
  '😄',
  '😅',
  '😆',
  '😉',
  '😊',
  '😋',
  '😎',
  '😍',
  '😘',
  '🥰',
  '😗',
  '😙',
  '😚',
  '🙂',
  '🤗',
  '🤩',
  '🤔',
  '🤨',
  '😐',
  '😑',
  '😶',
  '🙄',
  '😏',
  '😣',
  '😥',
  '😮',
  '🤐',
  '😯',
  '😪',
  '😫',
  '🥱',
  '😴',
  '😌',
  '😛',
  '😜',
  '😝',
  '🤤',
  '😒',
  '😓',
  '😔',
  '😕',
  '🙃',
  '🤑',
  '😲',
  '🙁',
  '😖',
  '😞',
  '😟',
  '😤',
  '😢',
  '😭',
  '😦',
  '😧',
  '😨',
  '😩',
  '🤯',
  '😬',
  '😰',
  '😱',
  '🥵',
  '🥶',
  '😳',
  '🤪',
  '😵',
  '🥴',
  '😠',
  '😡',
  '🤬',
  '😷',
  '🤒',
  '🤕',
  '🤢',
  '🤮',
  '🤧',
  '😇',
  '🥳',
  '🥺',
  '🤠',
  '🤡',
  '🤥',
  '🤫',
  '🤭',
  '🧐',
  '🤓',
  '😈',
  '👿',
  '👹',
  '👺',
  '💀',
  '☠',
  '👻',
  '👽',
  '👾',
  '🤖',
  '💩',
  '😺',
  '😸',
  '😹',
  '😻',
  '😼',
  '😽',
  '🙀',
  '😿',
  '😾',
  '🐱‍👤',
  '🐱‍🏍',
  '🐱‍💻',
  '🐱‍🐉',
  '🐱‍👓',
  '🐱‍🚀',
  '🙈',
  '🙉',
  '🙊',
  '🐵',
  '🐶',
  '🐺',
  '🐱',
  '🦁',
  '🐯',
  '🦒',
  '🦊',
  '🦝',
  '🐮',
  '🐷',
  '🐗',
  '🐭',
  '🐹',
  '🐰',
  '🐻',
  '🐨',
  '🐼',
  '🐸',
  '🦓',
  '🐴',
  '🦄',
  '🐔',
  '🐲',
  '🐽',
  '🐾',
  '🐒',
  '🦍',
  '🦧',
  '🦮',
  '🐕‍🦺',
  '🐩',
  '🐕',
  '🐈',
  '🐅',
  '🐆',
  '🐎',
  '🦌',
  '🦏',
  '🦛',
  '🐂',
  '🐃',
  '🐄',
  '🐖',
  '🐏',
  '🐑',
  '🐐',
  '🐪',
  '🐫',
  '🦙',
  '🦘',
  '🦥',
  '🦨',
  '🦡',
  '🐘',
  '🐁',
  '🐀',
  '🦔',
  '🐇',
  '🐿',
  '🦎',
  '🐊',
  '🐢',
  '🐍',
  '🐉',
  '🦕',
  '🦖',
  '🦦',
  '🦈',
  '🐬',
  '🐳',
  '🐋',
  '🐟',
  '🐠',
  '🐡',
  '🦐',
  '🦑',
  '🐙',
  '🦞',
  '🦀',
  '🐚',
  '🦆',
  '🐓',
  '🦃',
  '🦅',
  '🦢',
  '🦜',
  '🦩',
  '🦚',
  '🦉',
  '🐦',
  '🐧',
  '🐥',
  '🐤',
  '🐣',
  '🦇',
  '🦋',
  '🐌',
  '🐛',
  '🦟',
  '🦗',
  '🐜',
  '🐝'
];
